"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const clsx_1 = __importDefault(require("clsx"));
require("./MapmakerTilebar.css");
function MapmakerTilebar(_a) {
    var { children } = _a, props = __rest(_a, ["children"]);
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({}, props, { className: (0, clsx_1.default)("mapmaker-tilebar", props.className) }, { children: children })));
}
exports.default = MapmakerTilebar;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWFwbWFrZXJUaWxlYmFyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvcHJvamVjdC9zaGFyZWQvdGlsZWJhci9NYXBtYWtlclRpbGViYXIudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsZ0RBQXdCO0FBRXhCLGlDQUErQjtBQUkvQixTQUF3QixlQUFlLENBQUMsRUFHRztRQUhILEVBQ3RDLFFBQVEsT0FFaUMsRUFEdEMsS0FBSyxjQUY4QixZQUd2QyxDQURTO0lBRVIsT0FBTyxDQUNMLGdEQUFTLEtBQUssSUFBRSxTQUFTLEVBQUUsSUFBQSxjQUFJLEVBQUMsa0JBQWtCLEVBQUUsS0FBSyxDQUFDLFNBQVMsQ0FBQyxnQkFDakUsUUFBUSxJQUNMLENBQ1AsQ0FBQztBQUNKLENBQUM7QUFURCxrQ0FTQyJ9